import {
  collectionGroup,
  or,
  query,
  where,
  type QueryDocumentSnapshot,
} from 'firebase/firestore'
import { type FirestoreRoomStateAI, schema } from './schema'
import { type FirebaseRepository } from '../../models/FirebaseRepository'
import {
  collectionSnapshots,
  convertDocumentSnapshotToModel,
} from '../../firestore-mobx/stream'
import { RoomStateAI } from '../../models/RoomStateAI'
import { Timestamp } from 'firebase/firestore'

export * from './schema'

export const getUnsuccessfulAndRecentAIRuns = (
  repository: FirebaseRepository
) => {
  const EIGHT_DAYS_AGO = new Date(Date.now() - 8 * 24 * 60 * 60 * 1000)
  const colGroup = collectionGroup(repository.firestore, 'ai')

  // and either not ended or ended within last 8 days
  const q = query(
    colGroup,
    or(where('endedAt', '>', EIGHT_DAYS_AGO), where('endedAt', '==', null))
  )

  return collectionSnapshots(q).map((snap) => {
    const { docs } = snap

    return docs
      .filter((doc) => {
        const parentCollectionId = doc.ref.parent.parent?.parent?.id

        // only care about room_state entries
        if (parentCollectionId !== 'room_state') return false

        const { startedAt } = doc.data()

        // ignore entries with invalid startedAt
        if (!startedAt || !(startedAt instanceof Timestamp)) return false

        // filter out started at more than 8 days ago
        const startedOverEightDaysAgo = startedAt.toDate() < EIGHT_DAYS_AGO

        return !startedOverEightDaysAgo
      })
      .map((doc) => {
        // Cast so TS is happy with the fixedDoc we build later
        const baseDoc = doc as QueryDocumentSnapshot<FirestoreRoomStateAI>

        const parsedData = schema.parse(
          doc.data({ serverTimestamps: 'estimate' })
        )

        // Rebuild the doc with all the necessary fields and overriden data
        const fixedDoc: QueryDocumentSnapshot<FirestoreRoomStateAI> = {
          data: () => parsedData,
          exists: baseDoc.exists.bind(doc),
          get: baseDoc.get.bind(doc),
          id: baseDoc.id,
          ref: baseDoc.ref,
          metadata: baseDoc.metadata,
        }

        return convertDocumentSnapshotToModel(repository, fixedDoc, RoomStateAI)
      })
  })
}
